export const BG_PRIMARY = '#F5F6E8';
export const BG_SECONDARY = '#8D3232';

export const TEXT_PRIMARY = '#8D3232';
export const TEXT_SECONDARY = '#F5F6E8';
export const TEXT_ALTERNATIVE = '#011c44';

export const BG_NAVIGATION = `#dca74f`;
export const ICON_NAVIGATION = `#FFF`;

export const DEFAULT_BUTTON_PROPS = '';
